module.exports = __webpack_public_path__ + "static/ksCube-98bcb0abb9cba6605d3a68138a8409d8.jpg";